export default "__VITE_ASSET__3e838177__"